import axios from 'axios';
import moment from 'moment';
import _ from 'lodash';

export default {
  data() {
    return {
      _requestsCount: 0
    };
  },
  computed: {
    token() {
      return localStorage.getItem('authToken');
    }
  },
  watch: {
    '$data._requestsCount'() {
      if (this.$data._requestsCount > 0) {
        this.blockUI();
      } else {
        this.releaseUI();
      }
      if (this.$data._requestsCount < 0) {
        // truncates value at 0
        this.$data._requestsCount = 0;
      }
    }
  },
  // vthis.releaseUI
  filters: {
    count(value) {
      if (!value) {
        return 0;
      }
      return value.length;
    },
    toDateStr(value) {
      const m = moment(value);
      if (m.isValid()) {
        //return m.format('YYYY-MM-DD');
        return m.format('MM/DD/YYYY');
      }
      return 'Invalid date';
    },
    get(value, property, defaultValue = '') {
      return _.get(value, property, defaultValue);
    },
    humanTimeFromNow(value) {
      return moment(value).fromNow();
    },
    fullDateString(value) {
      return moment(value).format('MMMM, D, YYYY');
    },
    shortifyText(value, size) {
      if (value.length < size) return value;
      else return value.substring(0, size) + '...';
    }
  },
  methods: {
    openLink(url) {
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('target', '_blank');
      document.body.appendChild(link);
      link.click();
    },
    downloadFileToBrowser(file, data) {
      const extension = this.getFileExtension(file.fileName);
      let blob_type = {};
      if (extension == 'pdf') {
        blob_type = { type: 'application/pdf' };
      }

      //console.log(file, data);
      const url = window.URL.createObjectURL(new Blob([data], blob_type));
      const link = document.createElement('a');
      link.href = url;
      /*if (extension != 'pdf') {
            link.setAttribute('download', fileName);
          } else {
            link.setAttribute('target', '_blank');
          }*/
      link.setAttribute('download', file.fileName);
      document.body.appendChild(link);
      link.click();
    },
    getFileExtension(filename) {
      return filename.substr(filename.lastIndexOf('.') + 1);
    },
    detailedDiff(lhs, rhs, iteratee = null) {
      return {
        added: _.differenceBy(lhs, rhs, iteratee),
        removed: _.differenceBy(rhs, lhs, iteratee)
      };
    },
    blockUI() {
      document.getElementsByTagName('html')[0].style.cursor = 'wait';
      document.getElementsByTagName('html')[0].style['pointer-events'] = 'none';
    },
    releaseUI() {
      document.getElementsByTagName('html')[0].style.cursor = 'auto';
      document.getElementsByTagName('html')[0].style['pointer-events'] = 'auto';
    },
    normalizeStr(value) {
      return value
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase()
        .trim();
    },
    hasPermission(permission, all = false) {
      if (
        permission == null ||
        permission == undefined ||
        permission.length == 0
      ) {
        throw new Error('Permission must have at least one ID');
      }
      // todo should isActive or isAllowed be validated in any way?
      const userPermissions = this.$store.state.userPermissions || [];
      const requiredPermission = []
        .concat(permission)
        .filter(Boolean)
        .map(p => ({ permissionID: p }));
      const intersectedPermissions = _.intersectionBy(
        userPermissions,
        requiredPermission,
        'permissionID'
      );
      if (all) {
        return intersectedPermissions.length == requiredPermission.length;
      } else {
        return intersectedPermissions.length > 0;
      }
    },
    hasRole(role) {
      if (typeof role == 'string') {
        role = role.toLowerCase();
        switch (role) {
          case 'ue group Admin':
          case 'ue group':
          case 'ueg':
            role = 10;
            break;
          case 'organization admin':
          case 'organization':
            role = 20;
            break;
          case 'division admin':
          case 'division':
            role = 30;
            break;
          case 'workgroup admin':
          case 'workgroup':
            role = 40;
            break;
        }
      }
      return this.$store.state.user.roles.some(r => r.roleID <= role);
    },
    // axiosRequest(method, url, data, headers = {}, responseType = 'json') {
    axiosRequest(
      method,
      url,
      data,
      { headers = {}, responseType = 'json', ...rest } = {}
    ) {
      if (method === undefined) {
        console.error('axiosRequest requires at least one argument');
        return null;
      }
      if (url === undefined) {
        url = method;
        method = 'GET';
      }
      method = method.toLowerCase();
      // this.blockUI();
      // console.log('method', method);
      // console.log('url', url);
      // console.log('headers', headers);
      // console.log('response', responseType);
      // console.log('rest', rest);

      this.$data._requestsCount++;
      return axios({
        method,
        baseURL: process.env.VUE_APP_BACKEND_API,
        url: url,
        responseType,
        headers: {
          Authorization: 'Bearer ' + this.token,
          ...headers
        },
        data: data ? data : null,
        params: data && method === 'get' ? data : null,
        ...rest
      }).finally(() => this.$data._requestsCount--);
    },
    showErrorMessage(error) {
      //we can concat the errors too if we think is better
      console.log(error);
      if (typeof error == 'string') {
        this.$toasted.error(error);
      } else if (
        error.response != undefined &&
        error.response.data.errors != undefined &&
        error.response.data.errors.length > 0
      )
        this.$toasted.error(error.response.data.errors[0].message);
      else if (error.response.data.message != '') {
        this.$toasted.error(error.response.data.message);
      }
    },
    showSuccessMessage(msg) {
      this.$toasted.success(msg);
    }
  }
};
